// Pure helpers extracted from QuickMetaPopover so the framework-free unit
// tests can exercise the edge-case branches (uidLabel resolution, never-
// edited derivation) without spinning up React + provider mocks.

// Reference fields like created_uid / updated_uid arrive on the wire as one
// of three shapes:
//   - { id: "...", display_name: "Admin User" }   ← resolved server-side
//   - "ade38f..."                                  ← raw uuid string (rare)
//   - null                                          ← unset (system-created)
// `uidLabel` collapses all three into a presentable string for the popover.
export function uidLabel(value: unknown): string {
    if (value == null) return "System";
    if (typeof value === "object") {
        const obj = value as { display_name?: unknown; id?: unknown };
        if (typeof obj.display_name === "string" && obj.display_name.length > 0) {
            return obj.display_name;
        }
        if (typeof obj.id === "string" && obj.id.length > 0) {
            return uuidPrefix(obj.id);
        }
        return "—";
    }
    if (typeof value === "string" && value.length > 0) {
        // Bare uuid string fallback — server should normally resolve this to
        // a {display_name} object for created_uid / updated_uid, but if not
        // we surface a truncated uuid prefix rather than the full string so
        // the popover stays readable.
        return uuidPrefix(value);
    }
    return "—";
}

function uuidPrefix(raw: string): string {
    return raw.slice(0, 8) + "…";
}

// Returns true when the record's last-update equals its creation time —
// indicating no edits since insert (auto-fields set updated_at_utc on insert
// too). Used to render "Never edited" instead of repeating the create
// timestamp on the Last-Modified row.
export function isNeverEdited(createdAt: unknown, updatedAt: unknown): boolean {
    return (
        typeof createdAt === "string"
        && typeof updatedAt === "string"
        && createdAt === updatedAt
    );
}
